import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'user/map', en);
i18next.addResourceBundle('jp', 'user/map', jp);
const MapPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/dashboard/map',
			component: React.lazy(() => import('./Map'))
		}
	]
};

export default MapPageConfig;
